module.exports = __webpack_public_path__ + "static/img/3.679dcb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user/3.png
// module id = E4OG
// module chunks = 0